module.exports = __webpack_public_path__ + "img/flor_menu.b5f1d9df.svg";